import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface ProtectedRouteProps {
    requiredRole?: "admin" | "distribuidor" | "reseller";
}

const ROLE_HOME: Record<string, string> = {
    admin:        "/dashboard",
    distribuidor: "/distribuidor/dashboard",
    reseller:     "/reseller/dashboard",
};

export function ProtectedRoute({ requiredRole }: ProtectedRouteProps) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    if (!user || user.status === 'pending' || user.status === 'blocked') {
        return <Navigate to="/login" replace />;
    }

    if (requiredRole && user.role !== requiredRole) {
        return <Navigate to={ROLE_HOME[user.role] ?? "/login"} replace />;
    }

    return <Outlet />;
}
